// extracted by mini-css-extract-plugin
module.exports = {"styledRow":"styles_styledRow__1mmLY","styledRow__header":"styles_styledRow__header__2XJaf","styledRow__footer":"styles_styledRow__footer__2K7AS"};